module.exports = __webpack_public_path__ + "static/cortex-value-learn-min-66361febc43da43f36fecbc5da9de745.png";